





























import { Component, Vue } from 'vue-property-decorator';
import { MaintenancePeriod } from '@/store/modules/maintenance';
import SvgLiquidLogo from '@/components/SvgLiquidLogo.vue';

@Component({
  components: {
    SvgLiquidLogo
  }
})
export default class Page extends Vue {
  private get messages(): string[] {
    const key: string = 'componentsMaintenanceView.maintenance-area-text2';
    const message: string = this.$store.state.maintenance.message || this.$t(key);
    return message.split('\n');
  }

  private get isPeriod(): boolean {
    if (this.$store.state.maintenance.start !== null) return true;
    if (this.$store.state.maintenance.end !== null) return true;
    return false;
  }

  private get start(): string | null {
    const period: MaintenancePeriod | null = this.$store.state.maintenance.start;
    if (period === null) return null;
    const year: string = `0000${period.year}`.slice(-4);
    const month: string = `00${period.month}`.slice(-2);
    const date: string = `00${period.date}`.slice(-2);
    const hour: string = `00${period.hour}`.slice(-2);
    const minute: string = `00${period.minute}`.slice(-2);
    return this.$tc('componentsMaintenanceView.start', 0, {
      year: year,
      month: month,
      date: date,
      hour: hour,
      minute: minute
    });
  }

  private get end(): string | null {
    const period: MaintenancePeriod | null = this.$store.state.maintenance.end;
    if (period === null) return null;
    const year: string = `0000${period.year}`.slice(-4);
    const month: string = `00${period.month}`.slice(-2);
    const date: string = `00${period.date}`.slice(-2);
    const hour: string = `00${period.hour}`.slice(-2);
    const minute: string = `00${period.minute}`.slice(-2);
    return this.$tc('componentsMaintenanceView.end', 0, {
      year: year,
      month: month,
      date: date,
      hour: hour,
      minute: minute
    });
  }
}
